<div style="text-align: center; min-width: 300px; max-width: 420px">
  <div mat-dialog-content>
    <lemon-dialog-header>
      {{ 'tositteet.maksukortit.tunnistettu.otsikko' | translate | async }}
    </lemon-dialog-header>

    <div>{{ 'tositteet.maksukortit.tunnistettu.teksti' | translate: { numero: kortinNumero, maksutapa: maksutavanNimi } | async }}</div>
    <div class="gray-text" style="margin-top: 1em; font-size: 90%">{{ 'tositteet.maksukortit.tunnistettu.lisarivi' | translate | async }}</div>
  </div>
  <div mat-dialog-actions style="padding-left: 0; padding-right: 0">
    <app-lemonaid-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Kortti tunnistettu -dialog: Ei nyt">{{ 'tositteet.maksukortit.tunnistettu.ei-nyt' | translate | async }}</app-lemonaid-secondary-button>
    <span style="display: inline-block; width: 8vw; max-width: 4em"></span>
    <app-lemonaid-primary-button (click)="yhdista()" actionId="Kortti tunnistettu -dialog: Yhdistä">{{ 'tositteet.maksukortit.tunnistettu.yhdista' | translate | async }}</app-lemonaid-primary-button>
  </div>
  <div style="padding-bottom: 1em">
    <button mat-button type="button" class="ala-kysy-linkki" (click)="alaKysy()">{{ 'tositteet.maksukortit.tunnistettu.ala-kysy' | translate | async }}</button>
  </div>
</div>
